import React from "react"; 

export default function Pagination({ page, handlePagination, nextPage, totalItemsLength, totalItems }) {


  const getPagination = () => {
    let finalTotalCount;
    const numberOfItems = totalItemsLength - 1;
    var startRecord =  page == 1 ? page : ((10 * (page - 1)) + 1);
    var endRecord = (parseInt(startRecord) + numberOfItems) ;
    let lastpart;
    if(totalItems == undefined){
      lastpart = ""
    }else{
      lastpart = `of ${totalItems}`
    }

    const finalDisplay = `${startRecord}-${endRecord} ${lastpart}`;
    return finalDisplay;
  }

  const pagination = (data, currentPage) => {
    handlePagination(data, currentPage);

  }

  return (
    <div className="form-group" style={{ float: 'right' }}>
      <label className="form-label">
      </label>
      <div className="selectgroup align-to-right paginations">
        <span>
          {getPagination()}
        </span>

        <i
          className={
            "fe " +
            (page <= 1 ? "not-active " : "cursorPointer ") +
            " fe-chevron-left"
          }
          onClick={(e) => pagination(e, (parseInt(page) - 1))}
          disabled={page <= 1}>
        </i>

        <i
          className={
            "fe " +
            (!nextPage ? "not-active " : "cursorPointer ") +
            " fe-chevron-right"
          }

          onClick={(e) => 
            pagination(e, parseInt(page) + 1)
          }
          disabled={!nextPage}></i>
      </div>
    </div>
  )
}